// Application configuration
const config = {
  apiUrl: import.meta.env.VITE_API_URL || '/', // Slash = always resolve from root, not relative to current page
  // Local preview mode: bypass Clerk login (paired with backend DEV_AUTH=true).
  // NEVER enable in production.
  devAuth: import.meta.env.VITE_DEV_AUTH === 'true',
};

export default config;
